<div style="margin: 20px">
  <mat-card>
    <mat-card-title style="padding: 10px 0 0px 20px">Summary</mat-card-title>
    <mat-card-subtitle style="padding: 0px 0 0px 20px">Chart</mat-card-subtitle>
    <mat-card-content>
      <div style="float: left; width: 50%">
        <plotly-plot
          [data]="pie_data1.data"
          [layout]="pie_data1.layout"
          [useResizeHandler]="true"
        >
        </plotly-plot>
      </div>
      <div style="float: left; width: 50%">
        <plotly-plot
          [data]="pie_data2.data"
          [layout]="pie_data2.layout"
          [useResizeHandler]="true"
        >
        </plotly-plot>
      </div>
      <div style="clear: both"></div>
      <div class="mat-card-title" style="padding: 10px 0 0px 20px">
        Ultimas Indicidencias
      </div>
      <div class="mat-card-subtitle" style="padding: 0px 0 0px 20px">
        Last Week
      </div>
      <table
        mat-table
        matSort
        [dataSource]="dataSourceLastAlarms"
        class="mat-elevation-z8"
      >
        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="uuid">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            UUID
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.uuid }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="dispositivo">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Dispositivo
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.dispositivo }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="alarma">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Alarma
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.nombre }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fecha">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            style="text-align: center"
          >
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ doTransformDate(element.fecha / 1000000) }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsLastAlarms"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsLastAlarms"
        ></tr>
      </table>
      <mat-paginator
        #paginator3="matPaginator"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title style="padding: 10px 0 0px 20px"
      >Listado de Tipos de Incidentes</mat-card-title
    >
    <mat-card-subtitle style="padding: 0px 0 0px 20px"
      >Alarm Types</mat-card-subtitle
    >
    <mat-card-content>
      <div style="float: left">
        <mat-form-field style="padding-left: 20px">
          <input
            matInput
            type="text"
            (keyup)="doFilter(0, $event)"
            placeholder="Filter"
          />
        </mat-form-field>
      </div>
      <div style="float: right">
        <button
          mat-raised-button
          (click)="doOpenDialog(-1, -1, -1, -1)"
          color="primary"
          style="margin: 10px 20px 10px 0px"
        >
          Añadir
        </button>
      </div>
      <div style="clear: both"></div>
      <table
        mat-table
        [dataSource]="dataSourceTypesAlarms"
        class="mat-elevation-z8"
      >
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="uuid">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            UUID
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.uuid }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Nombre
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.nombre }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <!--
        <ng-container matColumnDef="descripcion">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Descipción </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.descripcion}} </td>
        </ng-container>
        -->

        <!-- Symbol Column -->
        <ng-container matColumnDef="cantidad">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Ocurrencias
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.ocurrencias }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="notificar">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Notificar
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            1
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="dispositivo">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Dispositivo
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.dispositivo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="visualizar">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Visualizar
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <button
              mat-raised-button
              (click)="
                doHighlight(element);
                doOpenDialog(
                  element.uuid,
                  -1,
                  element.dispositivoUuid,
                  element.nombre
                )
              "
              color="primary"
              style="margin: 5px 2px"
            >
              Detalle
            </button>
            <button
              mat-raised-button
              (click)="
                doOpenDialog(
                  element.uuid,
                  -2,
                  element.dispositivoUuid,
                  element.nombre
                )
              "
              color="primary"
              style="margin: 5px 2px"
            >
              Usuarios
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Acciones
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <button
              mat-raised-button
              (click)="
                doOpenDialog(
                  element.uuid,
                  0,
                  element.dispositivoUuid,
                  element.nombre
                )
              "
              color="accent"
              style="margin: 5px 2px"
            >
              Editar
            </button>
            <button
              mat-raised-button
              (click)="
                doOpenDialog(
                  element.uuid,
                  1,
                  element.dispositivoUuid,
                  element.nombre
                )
              "
              color="warn"
              style="margin: 5px 2px"
            >
              Eliminar
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsTypesAlarms"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsTypesAlarms"
          (click)="doHighlight(row)"
          [style.background]="
            highlightedRows.indexOf(row) != -1 ? 'lightblue' : ''
          "
        ></tr>
      </table>
      <mat-paginator
        #paginator1="matPaginator"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
      <div style="padding: 0 15px 15px 15px">
        <mat-card>
          <mat-card-title style="padding-left: 20px"
            >Listado de Alarmas por Tipo de Incidente</mat-card-title
          >
          <mat-card-subtitle style="padding-left: 20px"
            >Alarm: {{ currentAlarm }}</mat-card-subtitle
          >
          <mat-card-content>
            <div>
              <mat-form-field style="padding-left: 20px">
                <input
                  matInput
                  type="text"
                  (keyup)="doFilter(1, $event)"
                  placeholder="Filter"
                />
              </mat-form-field>
            </div>
            <table
              mat-table
              #alarmsTable
              [dataSource]="dataSourceListAlarms"
              class="mat-elevation-z8"
            >
              <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

              <!-- Position Column -->
              <ng-container matColumnDef="uuid">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  UUID
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ element.uuid }}
                </td>
              </ng-container>

              <!-- Position Column -->
              <ng-container matColumnDef="dispositivo">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Dispositivo
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  <div *ngFor="let campaign of element.campaign">
                    {{ campaign.dispNombre }}
                  </div>
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="campaña">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Campaña
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  <div *ngFor="let campaign of element.campaign">
                    {{ campaign.nombre }}
                  </div>
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="alarma">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Alarma
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ element.alarma }}
                </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="timestamp">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Fecha
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ doTransformDate(element.fecha / 1000000) }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsListAlarms"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsListAlarms"
              ></tr>
            </table>
            <mat-paginator
              #paginator2="matPaginator"
              [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons
            ></mat-paginator>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-card-content>
  </mat-card>
</div>
